import React, { useEffect } from 'react';

import { connect } from 'react-redux';
import { AnyAction } from 'redux';
import { ThunkDispatch } from 'redux-thunk';

import Badge from '@material-ui/core/Badge';

import { loadEmployeeMessages } from '../../messages/actions/load-employee-messages';
import { employeeMessagesForOrgIdSelector } from '../../reducers/message-selectors';

const mapStateToProps = (state: any, ownProps: InputProps) => ({
  messages: employeeMessagesForOrgIdSelector(state, ownProps.orgId),
});

const mapDispatchToProps = (
  dispatch: ThunkDispatch<any, any, AnyAction>,
  ownProps: InputProps,
) => ({
  actions: {
    loadEmployeeMessages: () => dispatch(loadEmployeeMessages(ownProps.orgId)),
  },
});

type InputProps = {
  orgId: number;
};

type StateProps = ReturnType<typeof mapStateToProps>;
type DispatchProps = ReturnType<typeof mapDispatchToProps>;
type Props = InputProps & StateProps & DispatchProps;

export const EmployeeUnreadMessagesBadge = connect(
  mapStateToProps,
  mapDispatchToProps,
)((props: Props) => {
  useEffect(() => {
    props.actions.loadEmployeeMessages();
  });

  const unreadMessagesCount = (props.messages || []).filter((m) => m.unread).length;

  if (unreadMessagesCount === 0) {
    return null;
  }

  return (
    <>
      <div className="leftNav-badge--collapsed" />
      <div className="leftNav-badge--expanded">
        <Badge badgeContent={unreadMessagesCount} max={10} color="secondary">
          <div />
        </Badge>
      </div>
    </>
  );
});
